import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const About = () => (
  <div>
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-20 pb-16">
      <div className="section-eyebrow text-[#0d2a20]/60 mb-6 fade-up">About Vemoye</div>
      <h1 className="hero-title text-[46px] md:text-[84px] leading-[1] max-w-[1200px] fade-up delay-1">An independent <span className="font-serif-i text-[#e0684d]">Ministry of Education</span> for Nigeria.</h1>
      <p className="mt-8 max-w-[820px] text-[17px] leading-relaxed text-[#0d2a20]/80 fade-up delay-2">Vemoye exists because we believe education is the most powerful nation-building tool available. Every society is shaped by the education system it creates. If we want a different future, we must build a different education system.</p>
    </section>

    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pb-24 grid md:grid-cols-3 gap-6">
      {[
        { t: 'Mission', d: 'To help build an education ecosystem that prepares young people to solve Nigeria\'s problems and contribute meaningfully to Africa\'s future.' },
        { t: 'Method', d: 'Consultancy, skills-based support, and capacity building for the organisations already doing this work — not another parallel programme.' },
        { t: 'Vision', d: 'To become the independent Ministry of Education supporting every part of the educational ecosystem across Nigeria — and eventually Africa.' },
      ].map(x => (
        <div key={x.t} className="rounded-lg p-8" style={{ background: '#fbf8ef' }}>
          <div className="section-eyebrow text-[#e0684d] mb-3">{x.t}</div>
          <p className="text-[15px] leading-relaxed text-[#0d2a20]/80">{x.d}</p>
        </div>
      ))}
    </section>

    <section style={{ background: '#0f3d2e', color: '#f4efe4' }}>
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-24 md:py-32">
        <div className="section-eyebrow text-[#f4efe4]/60 mb-8">The manifesto</div>
        <p className="hero-title text-[34px] md:text-[64px] leading-[1.05] max-w-[1200px]">The purpose of education is not simply to prepare children for exams. It is to prepare them for <span className="font-serif-i text-[#e0684d]">life, work, leadership,</span> and nation-building.</p>
        <p className="mt-10 text-[16px] leading-relaxed text-[#f4efe4]/80 max-w-[820px]">We believe that transferring knowledge can be just as valuable as transferring money. And that the Nigerians who left to build careers around the world are one of the greatest strategic assets Nigeria has never fully deployed.</p>
        <Link to="/join" className="inline-flex items-center gap-2 mt-10 px-5 py-3 rounded-md btn-coral text-[14px]">Join the movement <ArrowUpRight size={16} /></Link>
      </div>
    </section>
  </div>
);

export default About;
